import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { toUtcIsoString } from '@utils/date'
import {
  IMemberOpportunity,
  MemberOpportunitiesParams,
  MemberOpportunitiesResponse,
  MemberOpportunitiesStore,
  MemberOpportunityStatus
} from './types'

// staging sends `_created` without an offset; it is UTC either way
const normalize = (item: IMemberOpportunity): IMemberOpportunity => ({
  ...item,
  _created: toUtcIsoString(item._created) ?? null
})

export const useMemberOpportunitiesStore = create<MemberOpportunitiesStore>()(
  devtools(() => ({
    getMemberOpportunities: async ({
      opportunityType,
      page = 0,
      pageSize = 25,
      priority
    }: MemberOpportunitiesParams = {}) => {
      try {
        const params = new URLSearchParams()
        params.append('page', String(page))
        params.append('page_size', String(pageSize))
        if (opportunityType) {
          params.append('opportunity_type', opportunityType)
        }
        if (priority) {
          params.append('priority', priority)
        }

        const response = await http.get(
          `/dashboard/member_opportunities?${params.toString()}`
        )

        if (!response || !Array.isArray(response.results)) {
          return null
        }

        return {
          ...(response as MemberOpportunitiesResponse),
          results: response.results.map(normalize)
        }
      } catch (error) {
        console.error('Error fetching member opportunities:', error)
        return null
      }
    },

    updateOpportunityStatus: async (
      userId: number,
      opportunityId: number,
      status: MemberOpportunityStatus
    ) => {
      try {
        const response = await http.post(
          `/user/${userId}/member_opportunities/${opportunityId}/status`,
          { status }
        )
        return { success: response?.success === true }
      } catch (error) {
        console.error('Error updating the member opportunity status:', error)
        return { success: false }
      }
    }
  }))
)
